import React from 'react';
import { TextInput } from '../TextInput/TextInput';
import { cx } from '@emotion/css';
export const NumberInput = React.forwardRef(({ className, ...rest }, ref) => {
    return React.createElement(TextInput, { className: cx(className, 'ds-number-input'), ...rest, ref: ref, type: "number" });
});
NumberInput.displayName = 'NumberInput';
